import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const logIn = (authData) =>
  requestsTemplates.post(mainPath.replace('/api', ''), "/login",authData,undefined,false);
